export default "/images/artist4.png?c89b54d2ffd5257bd16f96b8fd3ad6f5";